import { IMatchHeader, IScoreboard } from "../../types/INote";
import styles from "./index.module.scss";
import StatusLabel from "../StatusLabel";
import { useEffect, useState } from "react";
import PhotoAPI from "../../services/photo-api";
import { fetchScoreboardData } from "../../services/api";

interface Props {
  xx: string;
  isRtcLive: boolean;
  isMobile: boolean;
  scoreboardWS?: IScoreboard;
}

const Scoreboard: React.FC<Props> = ({ xx, isRtcLive, isMobile, scoreboardWS }) => {
  const [matchHeader, setMatchHeader] = useState<IMatchHeader>();

  useEffect(() => {
    fetchScoreboardData({ articleId: xx })
      .then((response) => setMatchHeader(response.matchHeaders[0]))
      .catch(() => {
        /* Do nothing */
      });
  }, []);

  useEffect(() => {
    setMatchHeader(scoreboardWS?.matchHeaders[0]);
  }, [scoreboardWS]);

  if (!matchHeader) {
    return null;
  }

  return (
    <div className={[styles.scoreboard, isMobile ? styles.scoreboard__mobile : ""].join(" ")} data-e="scoreboard">
      <div className={styles.panel} data-e="scoreboard-panel">
        <div className={[styles.imageWrapper, isMobile ? styles.imageWrapper__mobile : ""].join(" ")}>
          <img
            src={PhotoAPI.photoFromXX(matchHeader.teamLeft.imageId.toString(), "J", "jpg")}
            alt={matchHeader.teamLeft.name}
            data-e="scoreboard-img"
          />
        </div>
        <span className={[styles.teamName, isMobile ? styles.teamName__mobile : ""].join(" ")} data-e="scoreboard-team">
          {matchHeader?.teamLeft.name}
        </span>
      </div>
      <div className={styles.scoreWrapper} data-e="scoreboard-wrapper">
        <div className={styles.scoreboard__mainDisplay}>
          <StatusLabel isRtcLive={isRtcLive} />
        </div>
        <div className={[styles.score, isMobile ? styles.score__mobile : ""].join(" ")} data-e="scoreboard-score">
          {matchHeader.scoreMain.replace(":", " : ")}
        </div>
        <div className={[styles.details, isMobile ? styles.details__mobile : ""].join(" ")} data-e="scoreboard-details">
          {matchHeader.scoreDetails}
        </div>
      </div>
      <div className={styles.panel} data-e="scoreboard-panel">
        <div className={[styles.imageWrapper, isMobile ? styles.imageWrapper__mobile : ""].join(" ")}>
          <img
            src={PhotoAPI.photoFromXX(matchHeader.teamRight.imageId.toString(), "J", "jpg")}
            alt={matchHeader.teamRight.name}
            data-e="scoreboard-img"
          />
        </div>
        <span className={[styles.teamName, isMobile ? styles.teamName__mobile : ""].join(" ")} data-e="scoreboard-team">
          {matchHeader.teamRight.name}
        </span>
      </div>
    </div>
  );
};

export default Scoreboard;
